import { Box, Tag, Text } from '@factorialco/deprecated-design-system'
import { TrainingCompetencyFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

interface Props {
  competencies: TrainingCompetencyFragment[]
}

export const Competencies = ({ competencies }: Props) => {
  if (competencies.length === 0) return <></>

  return (
    <Box
      width="s360"
      minHeight="s120"
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{ all: 'abs016' }}
      paddingY="s16"
      paddingX="s24"
      gap="s12"
    >
      <Text size="300" weight="semibold" color="grey1000">
        {i18n.t('trainings.training_requests.my_requests.datatable.columns.competencies')}
      </Text>
      <Box gap="s8">
        {competencies.map((competency) => (
          <CompetencyTag key={competency.id} competency={competency} />
        ))}
      </Box>
    </Box>
  )
}

interface CompetencyTagProps {
  competency: TrainingCompetencyFragment
}
const CompetencyTag = ({ competency }: CompetencyTagProps) => {
  if (!competency) return null

  return (
    <Tag inline type="grey">
      {competency.name}
    </Tag>
  )
}
